import script from "./BalCircle.vue?vue&type=script&setup=true&lang=ts"
export * from "./BalCircle.vue?vue&type=script&setup=true&lang=ts"

import "./BalCircle.vue?vue&type=style&index=0&id=cd2a3d52&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd2a3d52"]])

export default __exports__